import { ImageName } from "@mcleod/images";
import { ClickEvent, DataSourceExecutionEvent, DataSourceMode, Label, Snackbar, TableRow, TableRowDisplayEvent, TableRowExpansionEvent } from "@mcleod/components";
import { AutogenLayoutCompareHistoryList } from "./autogen/AutogenLayoutCompareHistoryList";
import { Api, McLeodClassicIntegration, Navigation, StringUtil } from "@mcleod/core";
import { CommonTooltips } from "@mcleod/common";
import { CompareOrder } from "./CompareOrder";
import { OrderTabView } from "@mcleod/dispatch";

export class CompareHistoryList extends AutogenLayoutCompareHistoryList {
    override onLoad() {
        this.checkboxErrorsPresent.allowIndeterminate = true;
        this.checkboxErrorsPresent.checked = undefined;
        this.switchNoChangesFound.allowIndeterminate = true;
        this.switchNoChangesFound.checked = undefined;
        this.textboxUserId.requiredDuringSearch = false;
        this.textboxTransactionType.requiredDuringSearch = false;
        this.textboxTargetOrderId.focus();
    }

    onTableRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        const imageProps = {
            imageWidth: 25,
            imageHeight: 20
        }
        const labelErrorsPresent = tableRow.findComponentById("labelErrorsPresent") as Label;
        if (labelErrorsPresent.text === "Yes") {
            labelErrorsPresent.imageName = ImageName.dfReplyError;
            labelErrorsPresent.setProps(imageProps);
        }
        labelErrorsPresent.text = "";
        const labelNoChangesFound = tableRow.findComponentById("labelNoChangesFound") as Label;
        if (labelNoChangesFound.text === "No") {
            labelNoChangesFound.imageName = ImageName.circleCheck;
            labelNoChangesFound.imageColor = "success";
            labelNoChangesFound.setProps(imageProps);
        }
        labelNoChangesFound.text = "";
        const labelTargetOrderId = tableRow.findComponentById("labelTargetOrderId") as Label;
        if (labelTargetOrderId.text !== "")
            labelTargetOrderId.addUnderlineWhenMouseOver();
        const labelSourceRecordId = tableRow.findComponentById("labelSourceRecordId") as Label;
        if (labelSourceRecordId.text !== "")
            labelSourceRecordId.addUnderlineWhenMouseOver();
        const labelTargetMoveId = tableRow.findComponentById("labelTargetMoveId") as Label;
        if (labelTargetMoveId.text !== "")
            labelTargetMoveId.addUnderlineWhenMouseOver();

        const labelName = tableRow.findComponentById("labelName") as Label;
        CommonTooltips.setTooltipContentLayout(
            labelName, null, "common/UserQuickInfo", null,
            {"name":labelName.text}
        );
    }

    sourceEdiCompareHistoryBeforeExecution(event: DataSourceExecutionEvent) {
        this.tableCompareHistory.displayData(null, null, 0);
        if (!((this.textboxTransactionType?.selectedItems?.length > 0)
            || !StringUtil.isEmptyString(this.textboxSourceRecordId.text)
            || !StringUtil.isEmptyString(this.textboxTargetMoveId.text)
            || !StringUtil.isEmptyString(this.textboxTargetOrderId.text)
            || !StringUtil.isEmptyString(this.textboxUserId.text)
            || !StringUtil.isEmptyString(this.textboxCompareDate.text)
            || this.switchNoChangesFound.checked !== undefined
            || this.checkboxErrorsPresent.checked !== undefined)
        ) {
            event.preventDefault();
            Snackbar.showWarningSnackbar("At least one search criteria must be entered");
        }
    }

    sourceEdiCompareHistoryAfterExecution(event: DataSourceExecutionEvent) {
        this.switchNoChangesFound.checked = undefined;
    }

    tableOnRowExpand(event: TableRowExpansionEvent) {
        if ((event.target as TableRow).data != null) {
            const row = (event.target as TableRow).data;
            const compareHistoryId = row.get("id");
            const expandComp = event.expandComponents[0] as CompareOrder;
            expandComp.visible = false;
            Api.search("lme/datafusion/compare-order", { compare_hist_id: compareHistoryId }).then(async result => {
                await expandComp.ensureLoaded();
                expandComp.setCompareHistoryFields();
                expandComp.visible = false;
                if (result.data[0]?.no_changes_found && result.data[0]?.no_changes_found === "Y") {
                    expandComp.tabsetCompare.visible = false;
                    expandComp.panelNoChangesFound.visible = true;
                } else {
                    expandComp.tabsetCompare.visible = true;
                    expandComp.panelNoChangesFound.visible = false;
                    expandComp.loadFromApiDataOrderHistory(result.data[0], DataSourceMode.SEARCH);
                }
                expandComp.visible = true;
            });
        }
    }

    orderNumberOnClick(event: ClickEvent) {
        if ((event.target as Label).text) {
            OrderTabView.navigateTo({ key: (event.target as Label).text, newTab: true });
        }
    }

    tenderNumberOnClick(event: ClickEvent) {
        if ((event.target as Label).text) {
            const tableRow = TableRow.getContainingTableRow(event.target as Label);
            const modelRow = tableRow.data;
            const transactionType = modelRow.get("transaction_type");
            if (transactionType === "T") {
                Navigation.navigateTo("lme/datafusion/ViewEdiOrder?mode=update&key=" + (event.target as Label).text, { newTab: true });
            } else if (transactionType === "I") {
                McLeodClassicIntegration.openClassicScreen("com.tms.client.loadmaster.edi.EntryEdiBilling",
                    (event.target as Label).text)
            }
        }
    }

    movementNumberOnClick(event: ClickEvent) {
        if ((event.target as Label).text) {
            const tableRow = TableRow.getContainingTableRow(event.target as Label);
            const modelRow = tableRow.data;
            if (!StringUtil.isEmptyString(modelRow.get("target_move_id")) && !StringUtil.isEmptyString(modelRow.get("target_order_id"))) {
                OrderTabView.navigateTo({ key: modelRow.get("target_move_id"), orderId: modelRow.get("target_order_id"), newTab: true });
            }
        }
    }
}
